/** Google Analytics helpers (GA4) – use when gtag is injected by server */

import type { LaunchMode } from '../constants/gameLaunchMode';

function isAccessLinkPage(): boolean {
    return /\/access\/[a-f0-9]+/i.test(window.location.pathname);
}

function gaEvent(eventName: string, eventParams?: Record<string, unknown>): void {
    if (typeof window.gtag === 'function' && window.GA_MEASUREMENT_ID) {
        window.gtag('event', eventName, eventParams || {});
    }
}

/** Forward custom events from game iframe to GA (matches main.js). */
export function forwardGameGaEvent(
    eventName: string | undefined,
    eventParams?: Record<string, unknown>
): void {
    if (typeof window.gtag === 'function') {
        window.gtag('event', eventName || 'game_event', eventParams || {});
    }
}

export function trackDemoView(): void {
    gaEvent('demo_view', { method: 'access_link', path: window.location.pathname });
}

export function trackGamesLoaded(games: { id: string }[]): void {
    gaEvent('games_loaded', {
        count: games.length,
        game_names: games.map((game) => game.id).join(','),
    });
    if (isAccessLinkPage()) {
        gaEvent('access_link_used', { path: window.location.pathname });
    }
}

export function trackGameLaunched(params: {
    game_name: string;
    game_url: string;
    launch_mode: LaunchMode;
}): void {
    gaEvent('game_launched', params);
}

export function trackGameClosed(gameName: string | null | undefined): void {
    gaEvent('game_closed', { game_name: gameName || 'unknown' });
}

export function trackGameReady(gameName: string | null | undefined): void {
    gaEvent('game_ready', { game_name: gameName || 'unknown' });
}
